export default __webpack_public_path__ + "static/media/18.9728a1db.jpg";